import { Component, OnInit, NgZone, Inject, ViewChild } from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-direccion-servicio',
  templateUrl: './direccion-servicio.component.html',
  styleUrls: ['./direccion-servicio.component.scss']
})
export class DireccionServicioComponent implements OnInit {
    public coords:{lat:number, lng:number};
    public buscador:FormControl;
    @ViewChild('buscador',{static:true}) public  input;
    public focoLat:number;
    public focoLng:number;
    public zoom:number;
    constructor(private apiMaps: MapsAPILoader, private ngZone: NgZone,@Inject(MAT_DIALOG_DATA) public data) {
        this.zoom = 13;
        this.focoLat = 4.8133302;
        this.focoLng = -75.6961136;
        this.coords = {
            lat:null,
            lng:null
        };
        if(this.data){
            if(this.data.coords){
                this.coords = {
                    lat:this.data.coords.lat,
                    lng:this.data.coords.lng
                };
            }
        }
    }

    ngOnInit() {
        this.buscador = new FormControl();
        this.apiMaps.load().then(()=>{
            console.log(google);
            let autocomplete = new google.maps.places.Autocomplete(this.input.nativeElement,{
                types:[]
            })

            autocomplete.addListener('place_changed',()=>{
                this.ngZone.run(()=>{
                    let place:google.maps.places.PlaceResult = autocomplete.getPlace();
                    if(place.geometry===undefined || place.geometry ===null) return;
                    this.focoLat = place.geometry.location.lat();
                    this.focoLng = place.geometry.location.lng();
                    this.zoom = 17;
                })
            })
        })
    }
    save(event: MouseEvent){
        this.coords.lat = event.coords.lat;
        this.coords.lng = event.coords.lng;
    }
}
